module.exports = __webpack_public_path__ + "img/color-s-2.288f639.webp";